import script from "./maintenance-request-item-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./maintenance-request-item-modal.vue?vue&type=script&setup=true&lang=ts"

import "./maintenance-request-item-modal.vue?vue&type=style&index=0&id=dca3d3b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dca3d3b8"]])

export default __exports__